const _debug = false;

const _config = {
    rotateLeft: "#rotateLeft",      //not used
    rotateRight: "#rotateRight",    //not used
}

export default class RotationControls {

    constructor(imageView, config) {
        this.imageView = imageView
        this.config = jQuery.extend(true, {}, _config, this.imageView.config.rotation, config);
        this.imageView.onRotate.subscribe(e => this.imageView.redraw());
    }

    rotateLeft() {
        this.imageView.openseadragon.viewport.rotateBy(-90);
    }

    rotateRight() {
        this.imageView.openseadragon.viewport.rotateBy(90);
    }

    rotateBy(degree) {
        this.imageView.openseadragon.viewport.rotateBy(degree);
    }

    rotateTo(degree) {
        this.imageView.openseadragon.viewport.rotateTo(degree);

    }

    close() {
        //NOOP
    }

}